export const SKILL_TOOL_NAME = 'Skill'
